import React, { useEffect, useState } from 'react';
import { Box, Card, CardBody, Image, Text, Flex, SimpleGrid, Spinner, Center, Select, Button, InputGroup, InputLeftElement, Input, Menu, MenuButton, MenuList, MenuItem, IconButton, Checkbox, MenuDivider, AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter, useToast, Badge, Switch, Stack, useColorModeValue } from '@chakra-ui/react';
import axiosClient from '../../axios-client';
import MyPagination from '../../components/MyPagination';
import { AiOutlineUserAdd } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PiPlusBold } from 'react-icons/pi';
import { SearchIcon } from '@chakra-ui/icons';
import { BsThreeDotsVertical } from "react-icons/bs";
import { useStateContext } from '../../context/ContextProvider';
import MySelect from 'react-select';
import { MdQueryStats } from 'react-icons/md';
import { ImStatsBars } from 'react-icons/im';

const ContentsStats = () => {
    const [movies, setMovies] = useState([]);
    const [contents, setContents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [paginationData, setPaginationData] = useState()
    const [selectedEtat, setSelectedEtat] = useState(null);
    const [loadingData, setLoadingData] = useState(true)
    const [searchTerm, setSearchTerm] = useState('');
    const [checkLengthData, setCheckLengthData] = useState(false)
    const navigate = useNavigate()
    const [currentPage, setCurrentPage] = useState(0);
    const [deleteId, setDeleteId] = useState(null);
    const toast = useToast()
    const { user } = useStateContext();
    const colorbg = useColorModeValue('white', '#2d3748')

    const txtcolor = useColorModeValue('black', 'white')
    const colorbghover = useColorModeValue('#e2e8f0', '#171923')
    const { t } = useTranslation()
    const cancelRef = React.useRef()

    ////////////////////////////////the size of the table//////////////////////////////
    const PAGE_SIZE = 16;
    const [pageSize, setPageSize] = useState(PAGE_SIZE);
    const handlePageSizeChange = (event) => {
        const newSize = parseInt(event.target.value, 16);
        setPageSize(newSize);
        setCurrentPage(0);
    };
    //////////////////////////////////////////////////////////////////////////////////
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const onOpenAlert = (id) => {
        setIsAlertOpen(true);
        setDeleteId(id)
    };

    const onCloseAlert = () => {
        setIsAlertOpen(false);
    };
    const [selectedSubcategory, setSelectedSubcategory] = useState(null);
    const [subcategoryOptions, setSubcategoryOptions] = useState([]);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    // Fetch Subcategories Grouped by Categories
    useEffect(() => {
        axiosClient.get('/subcategories/groupedByCats/')
            .then(response => {
                const formattedOptions = response.data.map(category => ({
                    label: category.category_name,
                    options: category.subcategories.map(sub => ({
                        value: sub.id,
                        label: sub.name
                    }))
                }));
                setSubcategoryOptions(formattedOptions);
            })
            .catch(error => {
                // console.error("Error fetching subcategories:", error)
            }
            );

        axiosClient.get('categories/')
            .then(response => {
                const formattedOptions = response.data.results.map(category => ({
                    value: category.id,
                    label: category.name
                }));
                setCategoryOptions(formattedOptions);
            })
            .catch(error => {
                // Handle error
            });
    }, []);
    useEffect(() => {
        setLoadingData(true)

        axiosClient.get(`/contents-stats/?page_size=${pageSize}&page=${currentPage + 1}&search_term=${searchTerm}&etat=${selectedEtat}&subcategory=${selectedSubcategory ? selectedSubcategory?.value : ''}&category=${selectedCategory ? selectedCategory?.value : ''}`)
            .then((response) => {

                let filteredData = response.data.results;
                setPaginationData(response.data);

                if (filteredData.length === 0) {
                    setCheckLengthData(true)
                }

                setContents(filteredData);

                setLoadingData(false)
            })
            .catch((error) => {
                // console.error(error);
                setLoadingData(false)
            });
    }, [selectedEtat, pageSize, currentPage, searchTerm, selectedSubcategory, selectedCategory]);

    // if (loadingData) {
    //     return (
    //         <Center h={'50vh'} mt={10}>
    //             <Spinner size="xl" />
    //         </Center>
    //     );
    // }

    if (error) {
        return (
            <Center mt={10}>
                <Text color="red.500">{error}</Text>
            </Center>
        );
    }



    return (
        <Box>
            <Flex pt='12px' mb={5}>
                <Box >
                    <Text fontFamily='Plus Jakarta Display' as="cite" fontSize={{ base: "18px", md: "20px", lg: "25px" }} color="gray">
                        <span onClick={() => navigate('/')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >
                            {t("Accueil")}
                        </span>  / <span >{t("Statistiques de visionnage")}</span>
                    </Text>
                </Box>

            </Flex>
            <Flex flexDirection={{ base: "column", lg: "row" }} py={5} justify={"end"}>
                {/* <Flex direction={{ base: 'column', md: "row" }} gap={2} w={{ base: '100%', lg: "60%" }}>
                    <Flex w={{ base: '100%', md: '50%', lg: "40%" }}>
                        <MySelect

                            options={categoryOptions}
                            onChange={setSelectedCategory}
                            placeholder="Catégorie"
                            isClearable
                            styles={{
                                container: (base) => ({
                                    ...base,
                                    zIndex: 99,
                                    width: '100%', // Make select take full width of parent (40%)
                                }),
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    border: '1px solid #CBD5E0',
                                    backgroundColor: 'transparent',
                                }),
                                menu: (provided) => ({
                                    ...provided,
                                    textAlign: 'left',
                                    backgroundColor: colorbg,
                                    cursor: "pointer"
                                }),

                                option: (provided, state) => ({
                                    ...provided,
                                    color: txtcolor,
                                    backgroundColor: state.isSelected ? colorbg : 'inherit',
                                    '&:hover': {
                                        backgroundColor: colorbghover,
                                    },
                                    cursor: "pointer"
                                }),
                                singleValue: (provided) => ({
                                    ...provided,
                                    color: txtcolor
                                }),



                            }}
                        />
                    </Flex>

                   
                </Flex> */}

                <InputGroup mb={3} size="md" w={{ base: '100%', lg: "40%" }}>
                    <InputLeftElement
                        pointerEvents='none'
                        children={<SearchIcon color='gray.300' />}
                    />
                    <Input
                        style={{ border: '1px solid #CBD5E0' }}

                        borderRadius="5"
                        placeholder={t("Recherche...")}
                        value={searchTerm}
                        onChange={(e) => {
                            setCurrentPage(0)
                            setSearchTerm(e.target.value)
                        }}

                        sx={{
                            marginLeft: 'auto',
                        }}
                    />  </InputGroup>

            </Flex>

            <SimpleGrid columns={!loadingData ? { base: 1, md: 2, lg: 4 } : { base: 1 }} spacing={5}>
                {!loadingData
                    ? contents.length > 0
                        ?
                        contents.map((obj) => (
                            <Card
                                // cursor={'pointer'} 
                                // onClick={() =>
                                //     navigate(`/detail-film`, {
                                //         state: {
                                //             movieId: movie.id,
                                //         },
                                //     })
                                // } 
                                key={obj.id} borderRadius="xl" overflow="hidden"
                                // overflow="hidden" 
                                height={{ base: "120px", sm: "120px", md: "150px" }}
                                boxShadow="md">
                                <Box position="relative">
                                    <Box position="absolute" top="5px" right="5px" zIndex="9" >
                                        <IconButton
                                         onClick={() =>
                                            navigate(`/content-stats`, {
                                                state: {
                                                    contentId: obj.id,
                                                },
                                            })
                                        } 
                                        size={"sm"}
                                        borderRadius="xl"
                                            // variant='outline'
                                            colorScheme='whiteAlpha'
                                            aria-label='Statistiques'
                                            icon={<ImStatsBars color='orange' size={18} />}
                                        />
                                    </Box>
                                    <Image borderRadius="xl" height={"100%"} width="100%" objectFit="cover" src={obj.image_Hquality || obj.image} alt={obj.title} />
                                    <CardBody
                                        borderRadius="md"
                                        position="absolute"
                                        top="0"
                                        left="0"
                                        right="0"
                                        bottom="0"
                                        p={4}
                                        height={{ base: "120px", sm: "120px", md: "150px" }}
                                        bg="rgba(0, 0, 0, 0.5)"
                                        color="white"
                                    // backdropFilter={"auto"}
                                    // backdropBlur={"2px"}
                                    >
                                        <Flex w={"100%"} height={{ base: "120px", sm: "120px", md: "150px" }} justify={"center"} direction={"column"}>
                                            <Text fontSize="lg" fontWeight="bold">{obj.title}</Text>
                                            <Text color="gray.300" fontSize="xl" fontWeight="semibold">
                                                regardé {obj.total_views} fois
                                            </Text>

                                        </Flex>

                                    </CardBody>
                                </Box>
                            </Card>
                        ))
                        : <Text >{t("Aucun contenu correspondant n'a été trouvé.")}</Text>

                    :
                    <Flex justify='center'>
                        <Spinner size="xl" />
                    </Flex>
                }

                {/* {(((searchTerm || selectedEtat !== null || selectedSubcategory !== null) && paginationData?.length === 0) || (checkLengthData)) && (
                    
                )} */}
            </SimpleGrid>
            <Flex flexDirection={{ base: 'column', lg: "row" }} justify="space-between" align="center" w="100%">
                <Box flex="1">
                    <MyPagination
                        paginationData={paginationData}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        PAGE_SIZE={pageSize}
                    />
                </Box>

                <Select w="70px" value={pageSize} onChange={handlePageSizeChange}>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="40">40</option>
                    <option value="50">50</option>
                </Select>
            </Flex>

        </Box>
    );
};

export default ContentsStats;
